module.exports = __webpack_public_path__ + "img/09-government-support.62929990.jpg";